import React from "react";
import { FaSun, FaMoon } from "react-icons/fa";
import { FiLogOut } from "react-icons/fi";
import { useAuth } from "../context/AuthContext";
import "./header.css";

/*
 Header props:
 - onToggleTheme: function to toggle light/dark
 - theme: 'light' | 'dark'
*/
export default function Header({ onToggleTheme, theme }) {
  const { userData } = useAuth();
  const userName = userData?.username || "Admin";
  const displayName = userName.charAt(0).toUpperCase() + userName.slice(1);
  const handleLogout = () => {
    // dispatch an app-wide logout event so App.js can handle navigation/cleanup
    const ev = new Event("app:logout");
    window.dispatchEvent(ev);
  };

  return (
    <header className="app-header">
      <div className="header-left">
        <h1 className="welcome">Welcome, {displayName}</h1>
      </div>

      <div className="header-right">
        <button
          className="theme-toggle"
          onClick={onToggleTheme}
          aria-label="Toggle theme"
        >
          {theme === "light" ? <FaMoon /> : <FaSun />}
        </button>

        <button
          title="Logout"
          className="logout-btn"
          onClick={handleLogout}
          aria-label="Logout"
        >
          <FiLogOut />
        </button>
      </div>
    </header>
  );
}
